export const PUBLIC_API_BASE = "https://chula-api.nonarkara.org";

/**
 * The public dashboard is a static Cloudflare deployment, so it cannot serve
 * `/api/*` itself. Keep same-origin requests for local/self-hosted development,
 * but make the public hosts work even when a machine or CI runner does not have
 * the gitignored `.env.production` file.
 */
export function resolveApiBase(configured: string | undefined, hostname: string | undefined): string {
  const explicit = configured?.trim().replace(/\/+$/, "");
  if (explicit) return explicit;
  if (hostname === "chula.nonarkara.org" || hostname?.endsWith(".pages.dev")) {
    return PUBLIC_API_BASE;
  }
  return "";
}

export const API_BASE = resolveApiBase(
  import.meta.env.VITE_API_BASE_URL as string | undefined,
  typeof window === "undefined" ? undefined : window.location.hostname,
);
